<template>
  <div class="tabs">
    <div v-for="(item, index) in tabsName" :key="item" :class="index == activeIndex ? 'activeTab' : 'normalTab'" :style="`width:${94/tabsName.length}%`" @click="active(index)">{{item}}</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      tabsName: ['待使用', '已使用', '已取消', '已过期'],
      activeIndex: 0
    };
  },

  props: ['tabs'],

  methods: {
    active(index) {
      this.activeIndex = index
      this.$parent.activeTab(index)
    }
  },

  created() {
    this.tabsName = this.tabs && this.tabs.length ? this.tabs : this.tabsName
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.tabs{
  background-color: #f6f6f6;
  text-align: center;
  line-height: 1.2rem;
  font-size: 0.4rem;
  color: #333;
  padding: 0 3%;
  padding-top: 0.3rem;
  div{
    display: inline-block;
    font-weight: 500;
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;
    cursor: pointer;
  }
  .normalTab{

  }
  .activeTab{
    color: #fff;
  }
}
</style>
